// Function to format timestamps
export function formatTimestamp(timestamp) {
    const date = new Date(timestamp);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} hrs`;
}

export function formatToDayMonthYear(dateString){
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
}

// Function to capitalize the first letter of a string
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

// Function to truncate a string to a certain length and add ellipsis
export function truncateString(str, num) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
}

export function getTodayDate(){
    return new Date().toISOString().split("T")[0]; 
}

export function formatCurrency(amount, showSymbol = true, showCents = false) {
    // Handle null/undefined/empty string
    if (amount === null || amount === undefined || amount === '') {
        return showSymbol ? 'KSh 0' : '0';
    }

    // Convert string numbers to numbers
    const numericAmount = typeof amount === 'string' ? 
        parseFloat(amount.replace(/[^0-9.-]/g, '')) : 
        amount;

    // Handle NaN cases
    if (isNaN(numericAmount)) {
        return 'Invalid amount';
    }

    // Kenyan formatting preferences
    const options = {
        minimumFractionDigits: showCents ? 2 : 0,
        maximumFractionDigits: showCents ? 2 : 0
    };

    // Format the number with Kenyan grouping
    const formattedAmount = new Intl.NumberFormat('en-KE', options).format(numericAmount);

    return showSymbol ? `KSh ${formattedAmount}` : formattedAmount;
}

// Alternative named export specifically for KES
export function formatKES(amount, showSymbol = true, showCents = false) {
    return formatCurrency(amount, showSymbol, showCents);
}

// Function to get the local date in YYYY-MM-DD format
export function getLocalDate() {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60000; // Offset in milliseconds
  const localDate = new Date(now.getTime() - offset);
  return localDate.toISOString().split('T')[0];
}